const Aside = () => {
  return (
    <aside className="ProductPage__aside">
      <ul>
        <li>
          <a href="#OATLY">OATLY | 瑞典</a>
        </li>
        <li>
          <a href="#CALIFIA">CALIFIA FARMS | 美國</a>
        </li>
        <li>
          <a href="#MINOR">MINOR FIGURES | 英國</a>
        </li>
        <li>
          <a href="#OATSIDE">OATSIDE | 新加坡</a>
        </li>
      </ul>
    </aside>
  );
};

export default Aside;
